import { connect } from 'react-redux'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import InitialHesitationWidget from './InitialHesitationWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(InitialHesitationWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/InitialHesitationWidgetContainer.js